/* eslint-disable no-undef */

// Function to check the meta tag and set the flag
function shouldUseSessionStorage() {
  const metaTag = document.querySelector('meta[name="use-session-storage"]');
  //return metaTag ? metaTag.getAttribute('content') === 'true' : true; // Default to true if not set
  return false;
}

// Global flag based on the meta tag
let useSessionStorage = shouldUseSessionStorage();

if (!useSessionStorage) {
  sessionStorage.removeItem('checkboxState');
  sessionStorage.removeItem('currentTabIndex');
  sessionStorage.removeItem('currentPageIndex');
  sessionStorage.removeItem('currentSubpageIndex');
}

// Init app

const tabs = document.querySelectorAll('.section_tab');
const progressComponent = document.querySelector('.progress_component');
let currentTabIndex = 0;
let currentPageIndex = 0;
let currentSubpageIndex = null; // Add this to track subpage index

// Initialize button variables
const continueButton = document.querySelector('.continue_component .button');
const backButton = document.querySelector('.back_component .button');
const avatar = document.querySelector('.user-menu_avatar'); // Select the avatar
const menu = document.querySelector('.user-menu_wrapper'); // Select the nav
const menuBackground = document.querySelector('.user-menu_background');
const sectionHeader = document.querySelector('.section_header'); // Select the section header
const sectionContent = document.querySelector('.section_content'); // Select the section content
const sectionFooter = document.querySelector('.section_footer'); // Select the section footer

let open = false;

// Function to display the current tab
function showTab(index) {
  tabs.forEach((tab, i) => {
    tab.style.display = i === index ? 'block' : 'none';
  });
}

// Adjusting showPage to handle subpages and preserve state when going back
function showPage(pageIndex, subpageIndex = 0) {
  const pages = tabs[currentTabIndex].querySelectorAll('.section_page');
  const subpages = pages[pageIndex].querySelectorAll('.section_subpage');
  let current = pages[pageIndex];

  // Show or hide pages
  pages.forEach((page, i) => {
    page.style.display = i === pageIndex ? 'block' : 'none';
  });

  // Show or hide subpages if they exist
  if (subpages.length > 0) {
    subpages.forEach((subpage, i) => {
      subpage.style.display = i === subpageIndex ? 'block' : 'none';
    });
    current = subpages[subpageIndex];
  }
  // Scroll to the top of the content area
  document.querySelector('.section_content').scrollTo(0, 0);

  // Reset the continue button state
  disableContinueButton();

  // Handle required interaction on the current page or subpage
  handleRequiredInteraction(current);

  // Restore the checkbox state and validate (disabled this since we aren't using sessionStorage anymore - let's test)
  //restoreAllCheckboxState(JSON.parse(sessionStorage.getItem('checkboxState') || '{}'));
  validateCheckboxes(); // Revalidate checkbox state for the current subpage

  // look for events to fire
  switch (current.getAttribute('trigger-event')) {
    case 'ready-page': {
      const readyPageEvent = new CustomEvent('ready-page', {
        detail: { message: 'Ready' },
      });
      document.dispatchEvent(readyPageEvent);
      break;
    }
    case 'experience-selection': {
      const experienceSelectionPageEvent = new CustomEvent('experience-selection', {
        detail: { message: 'Selecting Experience' },
      });
      document.dispatchEvent(experienceSelectionPageEvent);
      break;
    }
    case 'experience-page': {
      const experiencePageEvent = new CustomEvent('experience-page', {
        detail: { message: 'Doing the experience' },
      });
      document.dispatchEvent(experiencePageEvent);
      break;
    }
    case 'completed-page': {
      const completedEvent = new CustomEvent('completed-page', {
        detail: { message: 'Completed' },
      });
      document.dispatchEvent(completedEvent);
      break;
    }
    case 'start-pre-timer': {
      const preSessionTimerEvent = new CustomEvent('start-pre-timer', {
        detail: { message: 'Start Pre Session Timer' },
      });
      document.dispatchEvent(preSessionTimerEvent);
      break;
    }
    case 'end-pre-timer': {
      const preSessionEndTimerEvent = new CustomEvent('end-pre-timer', {
        detail: { message: 'End Pre Session Timer' },
      });
      document.dispatchEvent(preSessionEndTimerEvent);
      break;
    }
    case 'start-post-timer': {
      const postSessionTimerEvent = new CustomEvent('start-post-timer', {
        detail: { message: 'Start Post Session Timer' },
      });
      document.dispatchEvent(postSessionTimerEvent);
      break;
    }
    case 'end-post-timer': {
      const postSessionEndTimerEvent = new CustomEvent('end-post-timer', {
        detail: { message: 'End Post Session Timer' },
      });
      document.dispatchEvent(postSessionEndTimerEvent);
      break;
    }
    case 'pre-recovery-screen': {
      const preRecoveryScreenEvent = new CustomEvent('pre-recovery-screen', {
        detail: { message: 'Pre Recovery Screen Fitness' },
      });
      document.dispatchEvent(preRecoveryScreenEvent);
      break;
    }
    case 'recovery-screen': {
      const recoveryScreenEvent = new CustomEvent('recovery-screen', {
        detail: { message: 'Recovery Screen Fitness' },
      });
      document.dispatchEvent(recoveryScreenEvent);
      break;
    }
    case 'post-session-page': {
      const postSessionPageEvent = new CustomEvent('post-session-page', {
        detail: { message: 'Post Session Page Fitness' },
      });
      document.dispatchEvent(postSessionPageEvent);
      break;
    }
    case 'practice-session-page': {
      const practiceSessionPageEvent = new CustomEvent('practice-session-page', {
        detail: { message: 'Practice Session Page' },
      });
      document.dispatchEvent(practiceSessionPageEvent);
      break;
    }
    case 'practice-session-prep': {
      const practiceSessionPrepEvent = new CustomEvent('practice-session-prep', {
        detail: { message: 'Practice Session Prep' },
      });
      document.dispatchEvent(practiceSessionPrepEvent);
      break;
    }
    default:
      break;
  }

  closeMenu(); // Close menu if open
}

// Function to update the progress bar
function updateProgress() {
  const pages = tabs[currentTabIndex].querySelectorAll('.section_page');
  if (pages.length > 1) {
    progressComponent.innerHTML = ''; // Clear previous steps

    for (let i = 0; i < pages.length; i++) {
      const step = document.createElement('div');
      step.classList.add('progress_step');
      step.setAttribute('completed', i <= currentPageIndex ? 'true' : 'false');
      progressComponent.appendChild(step);
    }
  }
}

// Save the current state, including the subpage index
function saveState() {
  const allCheckboxes = getAllCheckboxState();
  // sessionStorage.setItem('currentTabIndex', currentTabIndex);
  // sessionStorage.setItem('currentPageIndex', currentPageIndex);

  // Save subpage index only if subpages exist
  if (currentSubpageIndex !== null) {
    // sessionStorage.setItem('currentSubpageIndex', currentSubpageIndex);
  } else {
    sessionStorage.removeItem('currentSubpageIndex'); // Clear it if not on a subpage
  }

  sessionStorage.setItem('checkboxState', JSON.stringify(allCheckboxes));
}

// Load saved state from sessionStorage (if it exists)
const savedTabIndex = sessionStorage.getItem('currentTabIndex');
const savedPageIndex = sessionStorage.getItem('currentPageIndex');
const savedSubpageIndex = sessionStorage.getItem('currentSubpageIndex'); // Restore subpage index
const savedCheckboxState = sessionStorage.getItem('checkboxState');

if (savedTabIndex !== null) {
  currentTabIndex = parseInt(savedTabIndex);
}

if (savedPageIndex !== null) {
  currentPageIndex = parseInt(savedPageIndex);
}

// Initial load: Show the saved or default tab and page
if (savedSubpageIndex !== null) {
  currentSubpageIndex = parseInt(savedSubpageIndex);
} else {
  currentSubpageIndex = 0; // Default to first subpage if no saved state
}

showTab(currentTabIndex);
showPage(currentPageIndex, currentSubpageIndex); // Add currentSubpageIndex here
updateProgress();
updateButtonsVisibility(); // Ensure button visibility is correct on load

// Assign listener to open menu
if (avatar && menu) {
  avatar.addEventListener('click', openMenu);
}

// Function to get checkbox state from all pages across all tabs
function getAllCheckboxState() {
  const allCheckboxes = document.querySelectorAll('input[type="checkbox"]');
  const checkboxState = {};
  allCheckboxes.forEach((checkbox, index) => {
    checkboxState[`action-${checkbox.id}`] = checkbox.checked;
  });
  return checkboxState;
}

// Function to restore checkbox states for all pages across all tabs
function restoreAllCheckboxState(checkboxState) {
  const allCheckboxes = document.querySelectorAll('input[type="checkbox"]');
  allCheckboxes.forEach((checkbox, index) => {
    if (checkboxState[`action-${checkbox.id}`]) {
      checkbox.checked = true;
    }
  });
  validateCheckboxes(); // Validate checkbox state after restoring
}

// Function to validate if all checkboxes are checked, or if there are no checkboxes at all
function validateCheckboxes() {
  const pages = tabs[currentTabIndex].querySelectorAll('.section_page');
  const subpages = pages[currentPageIndex].querySelectorAll('.section_subpage');
  let checkboxes;
  let requiredElements;
  let continueButtons;
  let backButtons;

  // Use subpages if they exist, otherwise use checkboxes from the page
  // If there are required elements that need to be clicked, keep the continue button disabled
  if (subpages.length > 0) {
    checkboxes = Array.from(
      subpages[currentSubpageIndex].querySelectorAll('input[type="checkbox"]')
    );
    requiredElements = subpages[currentSubpageIndex].querySelectorAll('[required-click=true]');
    continueButtons = subpages[currentSubpageIndex].querySelectorAll('[continue=true]');
    backButtons = subpages[currentSubpageIndex].querySelectorAll('[back=true]');
  } else {
    checkboxes = Array.from(pages[currentPageIndex].querySelectorAll('input[type="checkbox"]'));
    requiredElements = pages[currentPageIndex].querySelectorAll('[required-click=true]');
    continueButtons = pages[currentPageIndex].querySelectorAll('[continue=true]');
    backButtons = pages[currentPageIndex].querySelectorAll('[back=true]');
  }

  // Filter checkboxes with empty "action-id" and remove them from the DOM
  checkboxes.forEach((checkbox) => {
    if (!checkbox.getAttribute('action-id')) {
      checkbox.closest('.action_button-wrapper').remove(); // Remove from DOM if "action-id" is empty
    }
  });

  // Set the value to false if the requiredElement has the class "is-selected"
  if (requiredElements.length > 0) {
    disableContinueButton();
    requiredElements.forEach((requiredElement) => {
      if (requiredElement.classList.contains('is-selected')) {
        requiredElements = false;
        return;
      }
    });
  } else {
    requiredElements = false;
  }

  // If there continue buttons, hide the core continue button
  if (continueButtons.length > 0) {
    // Handle "Continue" button click
    continueButtons.forEach((element) => {
      element.addEventListener('click', advancePage);
    });
    continueButtons = true;
    disableContinueButton(true);
  } else {
    continueButtons = false;
  }

  // If there back buttons, set event
  if (backButtons.length > 0) {
    // Handle "Continue" button click
    backButtons.forEach((element) => {
      element.addEventListener('click', previousPage);
    });
  }

  // Now you have only checkboxes with valid "action-id" values in the DOM
  checkboxes = checkboxes.filter((checkbox) => checkbox.getAttribute('action-id'));

  // If there are no checkboxes or required element on the page/subpage, enable the continue button
  if (checkboxes.length === 0 && !requiredElements && !continueButtons) {
    enableContinueButton();
    return; // No need to check anything else
  }

  let allChecked = true;

  checkboxes.forEach((checkbox) => {
    if (!checkbox.checked) {
      allChecked = false;
    } else {
      checkbox.disabled = true;
    }

    // Find the nearest parent element with class 'card_status'
    const parentCard = checkbox.closest('.card_component');
    const cardStatus = parentCard.querySelector('.card_status');
    const cardModal = parentCard.querySelector('.card_modal'); // Find the modal in the card
    const modalButton = cardModal.querySelector('.modal_button'); // Find the modal button inside the card

    if (cardStatus) {
      // Add or remove the class based on checkbox value
      if (checkbox.checked) {
        cardStatus.classList.add('is-completed');
        cardStatus.classList.remove('is-incomplete');
        // Modify the child elements' text to "Completed"
        cardStatus.querySelector('.text-style-pill').textContent = 'Completed';
        checkbox.nextElementSibling.textContent = 'Completed';
        // Remove the modal button if it exists
        if (modalButton) {
          cardModal.classList.add('hide');
          modalButton.remove();
        }
      } else {
        cardStatus.classList.add('is-incomplete');
        cardStatus.classList.remove('is-completed');
        // Modify the child elements' text to "Need to Complete"
        cardStatus.querySelector('.text-style-pill').textContent = 'Need to Complete';
        checkbox.nextElementSibling.textContent = 'Mark Complete';
      }
    }

    // Add event listener to revalidate and save state when any checkbox is clicked
    checkbox.addEventListener('change', () => {
      validateCheckboxes(); // Validate checkboxes on change
      saveState(); // Save state whenever a checkbox is clicked
    });
  });

  if (allChecked && !requiredElements && !continueButtons) {
    enableContinueButton();
  } else {
    //disableContinueButton();
  }
}

// Function to handle required elements interaction
function handleRequiredInteraction(currentElement) {
  const requiredElements = currentElement.querySelectorAll('[required-click=true]');
  requiredElements.forEach((element) => {
    element.addEventListener('click', () => {
      enableContinueButton();
      // Optionally, you could give visual feedback by adding a 'selected' class
      requiredElements.forEach((el) => el.classList.remove('is-selected'));
      element.classList.add('is-selected');
    });
  });
}

// Function to disable the continue button
function disableContinueButton(hide = false) {
  if (continueButton) {
    continueButton.classList.add('is-disabled');
    continueButton.disabled = true;
    let sectionFooter = document.querySelector('.section_footer'); // Select the section footer
    if (hide) {
      sectionFooter.classList.add('hide');
    } else {
      sectionFooter.classList.remove('hide');
    }
  }
}

// Function to enable the continue button
function enableContinueButton() {
  if (continueButton) {
    continueButton.classList.remove('is-disabled');
    continueButton.disabled = false;
    let sectionFooter = document.querySelector('.section_footer'); // Select the section footer
    sectionFooter.classList.remove('hide');
  }
}

function openMenu() {
  if (open) {
    closeMenu();
    return;
  }
  if (menu) {
    menu.style.display = 'flex';
    menuBackground.style.display = 'block';
    if (sectionFooter) {
      sectionFooter.style.zIndex = 0;
    }
    menuBackground.addEventListener('click', closeMenu);
    open = true;
  }
}

function closeMenu() {
  if (menu) {
    menu.style.display = 'none';
    menuBackground.style.display = 'none';
    if (sectionFooter) {
      sectionFooter.style.zIndex = 1;
    }
    open = false;
  }
  sectionContent.style.overflow = 'scroll';
}

// Function to enable the continue button
function advancePage() {
  const pages = tabs[currentTabIndex].querySelectorAll('.section_page');
  const subpages = pages[currentPageIndex].querySelectorAll('.section_subpage');

  if (subpages.length > 0 && currentSubpageIndex < subpages.length - 1) {
    // Move forward within subpages
    currentSubpageIndex++;
    showPage(currentPageIndex, currentSubpageIndex);
    updateButtonsVisibility(); // Update button visibility
    saveState(); // Save the current state
  } else {
    // Move to the next page (or tab if on the last page)
    currentPageIndex++;
    currentSubpageIndex = 0; // Reset subpage index when moving to a new page

    // If on the last page of the current tab, move to the next tab
    if (currentPageIndex >= pages.length) {
      currentTabIndex++;
      currentPageIndex = 0; // Reset to the first page of the next tab
      currentSubpageIndex = 0; // Reset to the first subpage
    }

    // If there's a valid next tab, show it
    if (currentTabIndex < tabs.length) {
      showTab(currentTabIndex);
      showPage(currentPageIndex, currentSubpageIndex);
      updateProgress();
      saveState(); // Save the current state
      updateButtonsVisibility(); // Update button visibility
    }
  }
}

function previousPage() {
  const pages = tabs[currentTabIndex].querySelectorAll('.section_page');
  const subpages = pages[currentPageIndex].querySelectorAll('.section_subpage');

  // If on a subpage, go back within the subpages
  if (subpages.length > 0 && currentSubpageIndex > 0) {
    currentSubpageIndex--; // Go back to the previous subpage
    showPage(currentPageIndex, currentSubpageIndex);
  } else {
    // If not on a subpage or at the first subpage, go back to the previous page
    currentPageIndex--;

    // If on the first page of the current tab, go back to the previous tab
    if (currentPageIndex < 0) {
      currentTabIndex--;

      if (currentTabIndex >= 0) {
        const prevTabPages = tabs[currentTabIndex].querySelectorAll('.section_page');
        currentPageIndex = prevTabPages.length - 1; // Go to the last page of the previous tab
        const prevTabSubpages = prevTabPages[currentPageIndex].querySelectorAll('.section_subpage');

        // If there are subpages on the previous tab's page, go to the last subpage
        if (prevTabSubpages.length > 0) {
          currentSubpageIndex = prevTabSubpages.length - 1; // Go to the last subpage
        } else {
          currentSubpageIndex = 0; // No subpages, reset to the first subpage
        }
      } else {
        currentTabIndex = 0; // Stay on the first tab if there are no previous tabs
        currentPageIndex = 0;
        currentSubpageIndex = 0;
      }
    } else {
      // If there are subpages on the previous page, go to the last subpage
      const prevPageSubpages = pages[currentPageIndex].querySelectorAll('.section_subpage');
      if (prevPageSubpages.length > 0) {
        currentSubpageIndex = prevPageSubpages.length - 1; // Go to the last subpage
      } else {
        currentSubpageIndex = 0; // No subpages, reset to the first subpage
      }
    }
  }
  // Update UI with the correct tab, page, and subpage
  showTab(currentTabIndex);
  showPage(currentPageIndex, currentSubpageIndex);
  updateProgress();
  saveState(); // Save the current state
  updateButtonsVisibility(); // Update button visibility
}

// Handle "Continue" button click
if (continueButton) {
  // Handle "Continue" button click
  continueButton.addEventListener('click', advancePage);
}

// Handle "Back" button click
if (backButton) {
  // Adjusting Back button event listener to correctly navigate subpages
  backButton.addEventListener('click', previousPage);
}

// Adjusting updateButtonsVisibility to handle back button visibility on subpages
function updateButtonsVisibility() {
  const pages = tabs[currentTabIndex].querySelectorAll('.section_page');
  const subpages = pages[currentPageIndex].querySelectorAll('.section_subpage');
  // Create an event to fire on the final page
  const completed = new CustomEvent('completed', {
    detail: { message: 'Completed' },
  });

  if (backButton) {
    // Handle back button visibility for subpages
    if (currentPageIndex === 0 && currentSubpageIndex === 0 && currentTabIndex === 0) {
      backButton.style.display = 'none'; // Hide back button on the first subpage of the first page of the first tab
    } else {
      backButton.style.display = 'block'; // Show back button otherwise
    }
  }

  if (continueButton) {
    if (currentTabIndex === tabs.length - 1 && currentPageIndex === pages.length - 1) {
      if (subpages.length > 1) {
        if (currentSubpageIndex === subpages.length - 1) {
          continueButton.style.display = 'none';
          document.dispatchEvent(completed);
        } else {
          continueButton.style.display = 'block';
        }
      } else {
        continueButton.style.display = 'none'; // Hide continue button on the last subpage of the last page of the last
      }
    } else {
      continueButton.style.display = 'block'; // Show continue button otherwise
    }
  }
}

// Initalize sliders
function initSliders() {
  const sliders = document.querySelectorAll('.swiper');

  sliders.forEach((slider) => {
    const swiperInstance = new Swiper(slider, {
      slidesPerView: 1.25,
      spaceBetween: 16,
      cssMode: true,
      centeredSlides: true,
      createElements: true,
      navigation: true,
      pagination: {
        enabled: true,
        clickable: true,
        dynamicBullets: true,
      },
    });
  });
}

// Function to handle opening the modal
function openModal(modalButton) {
  const modalWrapper = modalButton.nextElementSibling; // Get the sibling modal wrapper
  const swiperWrapper = modalButton.closest('.swiper-wrapper'); // Select the closest swiper wrapper
  const swiperSlide = modalButton.closest('.swiper-slide'); // Select the closest swiper slide
  const iframeURL = modalButton.firstChild.getAttribute('iframe-url'); // Check if iframe-url attribute exists
  const actionId = modalButton.firstChild.getAttribute('action-id'); // Check if action-id attribute exists
  let swiperPagination = null;
  let swiperNext = null;
  let swiperPrev = null;

  if (modalWrapper) {
    modalWrapper.style.display = 'block'; // Show the modal
    sectionContent.style.overflow = 'hidden'; // Disable overflow

    if (swiperWrapper) {
      swiperPagination = $(swiperWrapper).siblings('.swiper-pagination')[0]; // Select the closest swiper pagination
      swiperNext = $(swiperWrapper).siblings('.swiper-button-next')[0]; // Select the closest swiper pagination
      swiperPrev = $(swiperWrapper).siblings('.swiper-button-prev')[0]; // Select the closest swiper pagination
      swiperWrapper.style.position = 'static'; // Set position to static when modal is open
      swiperWrapper.style.transform = 'none'; // Disable translate3d
      swiperSlide.style.transform = 'none'; // Disable translate3D
    }

    // Change z-index values when modal opens
    if (sectionHeader) sectionHeader.style.zIndex = '0';
    if (sectionFooter) sectionFooter.style.zIndex = '0';
    if (swiperPagination) swiperPagination.style.zIndex = '0';
    if (swiperNext) swiperNext.style.zIndex = '0';
    if (swiperPrev) swiperPrev.style.zIndex = '0';

    // Add event listeners to multiple elements for closing the modal
    const modalCloseElements = modalWrapper.querySelectorAll('.modal_close-button, label.button');
    modalCloseElements.forEach((closeElement) => {
      closeElement.addEventListener('click', () =>
        closeModal(
          modalWrapper,
          swiperWrapper,
          sectionHeader,
          sectionContent,
          sectionFooter,
          swiperPagination,
          swiperSlide,
          swiperNext,
          swiperPrev
        )
      );
    });

    // If iframe-url exists, dynamically load an iframe
    if (iframeURL) {
      const iframeSlot = modalWrapper.querySelector('.modal_slot'); // Select the .modal-slot element
      const actionWrapper = modalWrapper.querySelector('.action_button-wrapper');
      let iframe = iframeSlot.querySelector('iframe');
      if (actionWrapper && !actionId) actionWrapper.style.display = 'none'; // Hide complete button when loading iframe
      if (iframeSlot) {
        if (!iframe) {
          if (actionWrapper) actionWrapper.style.display = 'none'; // Hide complete button when loading iframe
          const iframe = document.createElement('iframe');
          iframe.src = iframeURL;
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          iframe.style.border = 'none'; // Remove border
          iframe.style.overflow = 'auto'; // Allow scrolling within iframe
          iframe.setAttribute('scrolling', 'auto'); // Allow scrolling
          iframe.setAttribute('allow', 'fullscreen; clipboard-read; clipboard-write; geolocation'); // Allow specific actions for interactivity
          iframeSlot.appendChild(iframe); // Append the iframe to the modal-slot

          // resize the iframe so that it will send back the correct width and height
          setTimeout(() => {
            iframe.style.height = '100px';
          }, 1000); // Short delay to allow reflow

          // Add iframe size adjustment and survey completion handling
          function setIframeSize(data, iframe) {
            if (data.zohosurvey) {
              if (data.zohosurvey.action === 'surveySize') {
                iframe.style.height = data.zohosurvey.height - 100 + 'px';
                modalWrapper.scrollTo(0, 0); // Scroll modal content to top
              } else if (data.zohosurvey.action === 'moveScroll') {
                modalWrapper.scrollTo(0, data.zohosurvey.position);
              }
            }
          }

          window.addEventListener(
            'message',
            function (e) {
              // console.log('data', e.data)
              setIframeSize(e.data, iframe);

              if (e.data && e.data['zohosurvey_respondentStatus'] === 'completed') {
                if (actionWrapper) actionWrapper.style.display = 'block'; // Show complete button if survey is completed
              }
            },
            false
          );
        }
      }
    }
  }
}

// Function to handle closing the modal
function closeModal(
  modalWrapper,
  swiperWrapper,
  sectionHeader,
  sectionContent,
  sectionFooter,
  swiperPagination,
  swiperSlide,
  swiperNext,
  swiperPrev
) {
  if (modalWrapper) {
    modalWrapper.style.display = 'none'; // Hide the modal
    if (swiperWrapper) {
      swiperWrapper.style.position = 'relative'; // Reset position back to relative
      swiperWrapper.style.transform = ''; // Reset transform to original
      swiperSlide.style.transform = ''; // Reset transform to original
    }
    sectionContent.style.overflow = 'scroll'; // Enable overflow
    // Reset z-index values when modal closes
    if (sectionHeader) sectionHeader.style.zIndex = '2';
    if (sectionFooter) sectionFooter.style.zIndex = '2';
    if (swiperPagination) swiperPagination.style.zIndex = '10';
    if (swiperNext) swiperNext.style.zIndex = '10';
    if (swiperPrev) swiperPrev.style.zIndex = '10';
  }
}

// Event listeners for modal buttons
document.querySelectorAll('.modal_component .modal_button').forEach((button) => {
  button.addEventListener('click', () => openModal(button));
});

// Load checkbox values from database
window.Wized = window.Wized || [];
window.Wized.push(async (Wized) => {
  let tasks = await Wized.requests.waitFor('get_onboarding_tasks');

  async function refreshCheckboxes() {
    // Loop through each object in the data array
    tasks.data.forEach(function (item) {
      // Find the checkbox with matching action_id
      let checkbox = document.querySelector(`input[type="checkbox"][action-id="${item.id}"]`);
      if (checkbox) {
        var isSession = checkbox.getAttribute('session');
      }
      // If checkbox exists, set its checked property based on the "completed" field
      // Check if session attribute is true or false, meaning it's a card that unique to the sessions.
      if (checkbox && isSession === 'false') {
        checkbox.checked = item.completed;
      }
    });

    // if in a session, we want to always reset the checkboxes since the user can't "resume" a session at a later time
    if (!Wized.data.n.path.includes('session')) {
      validateCheckboxes();
    }

    /*    if (Wized.data.v.in_session === null) {
      validateCheckboxes();
    }*/
  }

  Wized.on('requestend', (result) => {
    switch (result.name) {
      case 'get_onboarding_tasks':
        // Refresh Checkboxes
        refreshCheckboxes();
        break;
      default:
        break;
    }
  });

  await refreshCheckboxes();
});

initSliders(); // Initialize sliders on page load
